export default () => {
  const myCollapsible = document.getElementById('collapseReference')
  const collapseButtonWrapper = document.getElementById('collapse-reference-button')

  if (myCollapsible !== null && collapseButtonWrapper !== null) {
    myCollapsible.addEventListener('show.bs.collapse', function () {
      collapseButtonWrapper.classList.add('d-none')
    })
  }
}
